export const mapErrorForResponder = requestedResponders => Object.entries(requestedResponders).reduce((acc, [key, value]) => {
  acc[key] = {
    id: value.id,
    type: value.type,
    isError: true,
    acknowledged: true,
    isLoading: false
  };
  return acc;
}, {});
export const isNotLoaded = responder => !Boolean(responder === null || responder === void 0 ? void 0 : responder.isError) && !Boolean(responder === null || responder === void 0 ? void 0 : responder.acknowledged);